(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gepac-product-scale"] && !Shopify.designMode) return;
  try {
    
          try {
            let cardElements = document.getElementsByClassName('condition-card');
            let cards = [].slice.call(cardElements);
            let height;
  
            if (Array.isArray(cards) && cards.length > 1) {
              height = cards[0].scrollHeight;
            }
            
            for(let i = 0; i < cards.length; i++) {
              const CARD = cards[i];
  
              if (CARD.scrollHeight > height) {
                height = CARD.scrollHeight;
              }
            }
  
            cards.forEach(card => {
              card.style.height = `${height}px`;
            });
          } catch (error) {
            console.error('Error executing condition rating card javascript.')
          }
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
